<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch22"></a><a id="page_23"></a><a href="#/contents#ch22"><b>Loony</b></a></h2>
<p class="noindent"><span>Loons are aquatic birds that look like small ducks with black and white spots and red eyes.</span></p>
<p class="noindent"><span>There are five species of loons: common, red-throated, Pacific, arctic, and yellow-billed.</span></p>
<p class="noindent"><span>Loons get their name from their high-pitched yodeling cry. Many people say that it sounds like maniacal laughter.</span></p>
<p class="noindent"><span>Minnesota’s state bird: the common loon.</span></p>
<p class="noindent"><span>The birds have sharp beaks that they use to stab prey.</span></p>
<p class="noindent"><span>Loons are clumsy on land, and typically leave the water only to nest. They’re much faster and more agile when swimming.</span></p>
<p class="noindent"><span>Unlike most birds whose bones are hollow, loons’ bones are solid.</span></p>
<p class="noindent"><span>Loons can fly as fast as 75 mph.</span></p>
<p class="noindent"><span>A swimming loon appears on Canada’s one-dollar coin, nicknamed the “loonie.”</span></p>
<p class="noindent"><span>In England, loons are also called “divers” because they can dive as deep as 250 feet to look for fish, and can stay underwater for five minutes.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter22.vue?56026fb8